import { useEffect, useMemo } from 'react';
import { Icon } from '@iconify/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    getComplaintDetails,
    updateComplaint,
    getComplaintEnums,
    getComplaintCategories,
} from '../../../redux/actions/SocietyPortal/ComplaintAction/ComplaintAction';
import { getFlatsWithOwnership } from '../../../redux/actions/WingsAndFlatsActions/WingsAndFlatsAction';
import { selectedSocietyStorer } from '../../../utils/webStorer';
import { SOCIETY_PORTAL, SOCIETY_PORTAL_COMPLAINTS } from '../../../Routing/routes';
import ComplaintForm from './ComplaintForm';

const EditComplaint = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();

    const {
        updateComplaintLoading,
        complaintDetailsData,
        complaintDetailsLoading,
        complaintEnumsData,
        categoriesData,
    } = useSelector(state => state.ComplaintReducer || {});
    const { flatsWithOwnership } = useSelector(state => state.WingsAndFlatsReducers || {});
    const flats = useMemo(
        () => (Array.isArray(flatsWithOwnership) ? flatsWithOwnership : []),
        [flatsWithOwnership]
    );

    useEffect(() => {
        if (id) dispatch(getComplaintDetails({ id, societyId }));
    }, [dispatch, id, societyId]);

    useEffect(() => {
        if (!complaintEnumsData) dispatch(getComplaintEnums());
    }, [dispatch, complaintEnumsData]);

    useEffect(() => {
        if (societyId) dispatch(getComplaintCategories({ societyId }));
    }, [dispatch, societyId]);

    useEffect(() => {
        if (societyId) dispatch(getFlatsWithOwnership({ society_id: societyId }));
    }, [dispatch, societyId]);

    const handleSubmit = (payload) => {
        dispatch(updateComplaint({
            id,
            ...payload,
            onSuccess: () => navigate(SOCIETY_PORTAL + SOCIETY_PORTAL_COMPLAINTS),
        }));
    };

    const initial = complaintDetailsData ? {
        subject: complaintDetailsData.subject,
        description: complaintDetailsData.description,
        category_id: complaintDetailsData.category_id || '',
        priority: complaintDetailsData.priority,
        due_date: complaintDetailsData.due_date ? String(complaintDetailsData.due_date).slice(0, 10) : '',
        flat_id: complaintDetailsData.flat_id || '',
        wing_id: complaintDetailsData.wing_id || '',
        raised_at: complaintDetailsData.created_at,
    } : null;

    return (
        <div className="tw-p-5 tw-bg-gradient-to-br tw-from-gray-50 tw-to-slate-50 tw-min-h-screen">
            <div className="tw-max-w-4xl tw-mx-auto">
                <button
                    onClick={() => navigate(SOCIETY_PORTAL + SOCIETY_PORTAL_COMPLAINTS)}
                    className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-gray-600 hover:tw-text-gray-800 tw-mb-3"
                >
                    <Icon icon="mdi:arrow-left" /> Back to Complaints
                </button>
                <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm">
                    <div className="tw-p-4 tw-border-b tw-border-gray-100">
                        <h1 className="tw-text-base tw-font-bold tw-text-gray-800">Edit Complaint {complaintDetailsData?.complaint_code ? `— ${complaintDetailsData.complaint_code}` : ''}</h1>
                        <p className="tw-text-[11px] tw-text-gray-500 tw-mt-0.5">Update the complaint details. Status and assignment are managed on the View page.</p>
                    </div>
                    <div className="tw-p-5">
                        {complaintDetailsLoading && !initial ? (
                            <div className="tw-flex tw-justify-center tw-py-12">
                                <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-gray-200 tw-border-t-rose-500" />
                            </div>
                        ) : (
                            <ComplaintForm
                                initial={initial}
                                enums={complaintEnumsData}
                                categories={categoriesData}
                                flats={flats}
                                onSubmit={handleSubmit}
                                onCancel={() => navigate(SOCIETY_PORTAL + SOCIETY_PORTAL_COMPLAINTS)}
                                submitting={updateComplaintLoading}
                                submitLabel="Save Changes"
                                mode="edit"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditComplaint;
